module.exports = function formatColorMappings(arr1, colorCategory) {
      console.log("ARR1: ", arr1);
      console.log("CATE: ", colorCategory);
      let colorToneMappings;
      if(colorCategory === "brand") {
        colorToneMappings = {...brandToneMappings};
      }
      else if (colorCategory === "success") {
        colorToneMappings = {...successToneMappings};
      }
      else if (colorCategory === "warning") {
        colorToneMappings = {...warningToneMappings};
      }
      else if (colorCategory === "error") {
        colorToneMappings = {...errorToneMappings}; 
      }
      else if (colorCategory === "info") {
        colorToneMappings = {...infoToneMappings};
      }
      
      let finalMappedArray = [];
      //if(colorCategory === "success") {
        let hooksList;
        let lightTone, darkTone;
        let lightToneHex, darkToneHex;
        Object.keys(colorToneMappings).forEach(pairTones => {
          hooksList = colorToneMappings[pairTones];
          lightTone = pairTones.split('-')[0];
          darkTone = pairTones.split('-')[1];
       

          arr1.forEach(colorObj => {
            if(colorObj.label === lightTone) {
              lightToneHex = colorObj.hex;
            }
            if(colorObj.label === darkTone) {
              darkToneHex = colorObj.hex;
            }
          });
          if(hooksList && hooksList.length > 1) {
            hooksList.forEach(hook => {
                  finalMappedArray.push({
                       name: hook,
                       value: `light-dark(${lightToneHex},${darkToneHex})`
              });
            });
          }
          else {
            hooksList && finalMappedArray.push({
            name: hooksList[0],
            value: `light-dark(${lightToneHex},${darkToneHex})`
            }); 
          }
        });
      //}
      // else {
      //   arr1.forEach(colorObj => {
      //     let hooksList = colorToneMappings[colorObj.label];
      //   if(hooksList && hooksList.length > 1) {
      //       hooksList.forEach(hook => {
      //             finalMappedArray.push({
      //                  name: hook,
      //                  value: colorObj.hex
      //         });
      //     })
      //   }
      //   else{
      //     hooksList && finalMappedArray.push({
      //      name: hooksList[0],
      //      value: colorObj.hex
      //  }); 
      //   }
      // });
      // }
      
       return finalMappedArray;
}

const brandToneMappings = {
  '100': ["--slds-g-color-brand-base-base-100"],
  '95-10': ["--slds-g-color-accent-light-1", "--slds-g-color-brand-base-95"],
  '90-15': ["--slds-g-color-accent-light-2", "--slds-g-color-brand-base-90"],
  '80-20': ["--slds-g-color-brand-base-80"],
  '70-30': ["--slds-g-color-brand-base-70"],
  '65-40': ["--slds-g-color-brand-base-65"],
  '60-40': ["--slds-g-color-brand-base-60"],
  '50-50': ["--slds-g-color-accent-1", "--slds-g-color-accent-container-1", "--slds-g-color-border-accent-1", "--slds-g-color-brand-base-50"],
  '40-60': ["--slds-g-color-accent-2", "--slds-g-color-accent-container-2", "--slds-g-color-border-accent-2", "--slds-s-link-color", "--slds-g-color-brand-base-40"],
  '30-70': ["--slds-g-color-accent-3", "--slds-g-color-accent-container-3", "--slds-g-color-border-accent-3", "--slds-s-link-color-hover", "--slds-s-link-color-focus", "--slds-s-link-color-active", "--slds-g-color-brand-base-30"],
  '20-80': ["--slds-g-color-accent-dark-1", "--slds-g-color-brand-base-20"],
  '15-90': ["--slds-g-color-brand-base-15"],
  '10-95': ["--slds-g-color-accent-dark-2", "--slds-g-color-brand-base-10"],
 };

 const successToneMappings = {
   '95-10': ["--slds-g-color-success-base-95"],
   '90-15': [ "--slds-g-color-success-base-90"],
   '80-20': ["--slds-g-color-success-base-80"],
   '70-30': ["--slds-g-color-success-base-70"],
   '60-40': ["--slds-g-color-success-base-60"],
   '50-50': ["--slds-g-color-success-base-50"],
   '40-60': ["--slds-g-color-success-base-40"],
   '30-70': ["--slds-g-color-success-base-30"],
   '20-80': ["--slds-g-color-success-base-20"],
   '10-90': ["--slds-g-color-success-base-10"],
   '40-70': ["--slds-g-color-success-1", "--slds-g-color-border-success-1"],
   '90-30': ["--slds-g-color-success-container-1"],
   '80-40': ["--slds-g-color-success-container-2"],
   '40-90': ["--slds-g-color-on-success-1"],
   '30-95': ["--slds-g-color-on-success-2"],
   '30-80': ["--slds-g-color-border-success-2"],
 }

 const errorToneMappings = {
  '95-10': ["--slds-g-color-error-base-95"],
  '90-15': ["--slds-g-color-error-container-1", "--slds-g-color-error-base-90"],
  '80-20': ["--slds-g-color-error-container-2", "--slds-g-color-error-base-80"],
  '70-30': ["--slds-g-color-error-base-70"],
  '60-40': ["--slds-g-color-error-base-60"],
  '50-50': ["--slds-g-color-error-base-50"],
  '40-60': ["--slds-g-color-error-1", "--slds-g-color-on-error-1", "--slds-g-color-border-error-1", "--slds-g-color-error-base-40"],
  '30-70': ["--slds-g-color-on-error-2", "--slds-g-color-border-error-2", "--slds-g-color-error-base-30"],
  '20-80': ["--slds-g-color-error-base-20"],
  '10-90': ["--slds-g-color-error-base-10"],
  '40-70': ["--slds-g-color-error-1", "--slds-g-color-border-error-1"],
  '90-30': ["--slds-g-color-error-container-1"],
  '80-40': ["--slds-g-color-error-container-2"],
  '40-90': ["--slds-g-color-on-error-1"],
  '30-95': ["--slds-g-color-on-error-2"],
  '30-80': ["--slds-g-color-border-error-2"],
}

const warningToneMappings = {
  '95-10': ["--slds-g-color-warning-base-95"],
  '90-15': ["--slds-g-color-warning-container-1", "--slds-g-color-warning-base-90"],
  '80-20': ["--slds-g-color-warning-base-80"],
  '70-30': ["--slds-g-color-warning-base-70"],
  '60-40': ["--slds-g-color-warning-base-60"],
  '50-50': ["--slds-g-color-warning-base-50"],
  '40-60': ["--slds-g-color-warning-1", "--slds-g-color-on-warning-1", "--slds-g-color-warning-base-40"],
  '30-70': ["--slds-g-color-warning-base-30"],
  '20-80': ["--slds-g-color-warning-base-20"],
  '10-90': ["--slds-g-color-warning-base-10"],
  '40-70': ["--slds-g-color-warning-1", "--slds-g-color-border-warning-1"],
  '90-30': ["--slds-g-color-warning-container-1"],
  '40-90': ["--slds-g-color-on-warning-1"],
}

 const infoToneMappings = {
  '95-10': ["--slds-g-color-info-base-90"],
  '90-15': ["--slds-g-color-info-container-1"],
  '80-20': ["--slds-g-color-info-base-80"],
  '70-30': ["--slds-g-color-info-base-70"],
  '60-40': ["--slds-g-color-info-base-60"],
  '50-50': ["--slds-g-color-info-base-50"],
  '40-60': ["--slds-g-color-info-1", "--slds-g-color-on-info-1"],
  '30-70': ["--slds-g-color-info-base-30"],
  '20-80': ["--slds-g-color-info-base-20"],
  '10-95': ["--slds-g-color-info-base-10"],
  '40-70': ["--slds-g-color-info-1"],
  '90-30': ["--slds-g-color-info-container-1"],
  '40-90': ["--slds-g-color-on-info-1"],
}